export default __webpack_public_path__ + "static/media/three-dots.9e286ba9.svg";